import React from 'react';
import ReactDOM from 'react-dom/client';
import { SnackbarProvider } from 'notistack';
import App from './App';
import MobileApp from './MobileApp';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Force React to use production-like behavior in development mode
// This helps reduce the "[Violation] 'message' handler took <N>ms" warnings
if (process.env.NODE_ENV === 'development') {
  // This is a development-only optimization to reduce console warnings
  // It disables some of React's development checks that can cause performance issues
  // Note: This should only be used for testing performance issues
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (
      typeof args[0] === 'string' &&
      (args[0].includes('Warning:') || 
       args[0].includes('ReactDOM.render is no longer supported'))
    ) {
      return;
    }
    originalConsoleError(...args);
  };
}

// Function to detect mobile devices
const isMobileDevice = () => {
  // Check if user agent string contains mobile keywords
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
    return true;
  }
  
  // Check screen width as a fallback
  return window.innerWidth <= 768;
};

// Choose the appropriate app version based on device type
const AppComponent = isMobileDevice() ? MobileApp : App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Removed StrictMode to improve performance in development
  <SnackbarProvider anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} maxSnack={5}>
    <AppComponent />
  </SnackbarProvider>
);

// Unregister service worker to prevent caching issues
serviceWorkerRegistration.unregister();
